import { CreatePageVm } from "../../models/view/create-page.vm";

export class PageParamCommand {
    constructor(public  pageEntity: CreatePageVm) {
    }
}
